import { useContext } from "react";
import { UNSAFE_DataRouterContext } from "react-router-dom";

export const useDataRouterContext = () => {
  const dataRouterContext = useContext(UNSAFE_DataRouterContext);
  if (!dataRouterContext) {
    throw new Error("useDataRouterContext must be used within a data router");
  }
  return dataRouterContext;
};
